import { useMemo } from 'react';

import { useAuthUser } from 'hooks/useAuthUser';
import { ThemeProvider } from 'styled-components';

import breakpoints from './breakpoints';
import { oldHoustonTheme } from './oldhoustontheme';
import clubBlackTheme from './themes/clubBlack';
import defaultTheme from './themes/default';
import { type CustomHoustonTheme, type StyledHoustonThemeProps } from './types';

const StyledHoustonTheme = ({ children }: StyledHoustonThemeProps) => {
  const { data: userData } = useAuthUser();

  const userTheme = useMemo(() => (userData?.is_clube_black ? clubBlackTheme : defaultTheme), [userData]);

  const customHounstonTheme: CustomHoustonTheme = useMemo(
    () => ({ ...oldHoustonTheme, customBreakpoints: breakpoints, user: userTheme }),
    [userTheme]
  );

  return <ThemeProvider theme={customHounstonTheme}>{children}</ThemeProvider>;
};

export default StyledHoustonTheme;
